// 261023 E3-P3h4c (FE) — nạp «hộp hậu quả» (GET chỉ đọc) khi hộp mở. Không import antd (test được dưới jest).
// Preview lỗi / BE cũ chưa có endpoint / hình dạng lạ / treo quá hạn ⇒ `fallback`: caller vẽ HỘP XÁC NHẬN CŨ và vẫn cho bấm — preview không bao giờ chặn người dùng.
import { useCallback, useEffect, useRef, useState } from 'react';
import type { ConsequencePreview } from '../../../types/adaptationWorkbench';
import { consequenceViewOf, ConsequenceView } from './consequenceView';

export type ConsequenceStatus = 'idle' | 'loading' | 'ready' | 'fallback';
export interface ConsequenceState { status: ConsequenceStatus; view: ConsequenceView | null; reload: () => void }

/** Preview treo (không có timeout mạng) quá mức này ⇒ coi như lỗi ⇒ hộp cũ. */
export const PREVIEW_TIMEOUT_MS = 10000;

export const useConsequencePreview = (open: boolean, load: () => Promise<ConsequencePreview>, timeoutMs: number = PREVIEW_TIMEOUT_MS): ConsequenceState => {
  const [state, setState] = useState<{ status: ConsequenceStatus; view: ConsequenceView | null }>({ status: open ? 'loading' : 'idle', view: null });
  const [tick, setTick] = useState(0);
  const loadRef = useRef(load);
  loadRef.current = load;

  useEffect(() => {
    if (!open) { setState({ status: 'idle', view: null }); return undefined; }
    let alive = true;
    setState({ status: 'loading', view: null });
    const timer = setTimeout(() => { if (alive) { alive = false; setState({ status: 'fallback', view: null }); } }, timeoutMs);
    Promise.resolve()
      .then(() => loadRef.current())
      .then((raw) => {
        if (!alive) return;
        clearTimeout(timer);
        const view = consequenceViewOf(raw);
        setState(view ? { status: 'ready', view } : { status: 'fallback', view: null });
      })
      .catch(() => { if (alive) { clearTimeout(timer); setState({ status: 'fallback', view: null }); } });
    return () => { alive = false; clearTimeout(timer); };
  }, [open, tick, timeoutMs]);

  const reload = useCallback(() => setTick((n) => n + 1), []);
  return { ...state, reload };
};
